export var MediaAssetErrorCode = /*#__PURE__*/function (MediaAssetErrorCode) {
  MediaAssetErrorCode["NotReady"] = "NotReady";
  MediaAssetErrorCode["ForeignCloud"] = "ForeignCloud";
  MediaAssetErrorCode["NotFound"] = "NotFound";
  MediaAssetErrorCode["Invalid"] = "Invalid";
  MediaAssetErrorCode["UnknownProvider"] = "UnknownProvider";
  return MediaAssetErrorCode;
}(MediaAssetErrorCode || {});
export function getMediaAssetErrorCodeDescription(err) {
  switch (err) {
    case MediaAssetErrorCode.NotReady:
      return "Asset ist noch in Verarbeitung.";
    case MediaAssetErrorCode.ForeignCloud:
      return "Asset liegt in einer externen Cloud ohne API-Zugriff.";
    case MediaAssetErrorCode.NotFound:
      return "Asset wurde nicht gefunden.";
    case MediaAssetErrorCode.Invalid:
      return "Asset defekt - evtl. ist der Upload fehlgeschlagen.";
    case MediaAssetErrorCode.UnknownProvider:
      return "Assetfehler: Der angegebene Provider ist unbekannt.";
  }
}